import {
  Children,
  cloneElement,
  isValidElement,
  type Attributes,
  type ComponentProps,
  type ElementType,
  type ReactElement,
  type ReactNode,
} from 'react';

export function findChildOfType<T extends ElementType>(
  children: ReactNode,
  type: T,
): ReactElement<ComponentProps<T>> | undefined {
  return Children.toArray(children).find(
    (child): child is ReactElement<ComponentProps<T>> =>
      isValidElement(child) && child.type === type,
  );
}

export function applyInternalProps<InternalPropsType>(
  element: ReactElement | undefined,
  props: InternalPropsType & Attributes,
): typeof element {
  return element
    ? cloneElement(
        element as ReactElement<InternalPropsType>,
        props as Partial<InternalPropsType>,
      )
    : element;
}
